import Vue from 'vue'

export var bus = new Vue({
    methods: {
        GetAllDiscounts(response) {
            this.$emit('GetAllDiscounts', response)
        },
        CreateDiscount(response) {
            this.$emit('CreateDiscount', response)
        },
        GetAllCategorys(response) {
            this.$emit('GetAllCategorys', response)
        },
        CreateCategory(response) {
            this.$emit('CreateCategory', response)
        },
        GetAllNotify(response) {
            this.$emit('GetAllNotify', response)
        },
        CreateNotify(response) {
            this.$emit('CreateNotify', response)
        },
        DeleteNotify(response){
            this.$emit('DeleteNotify', response)
        },
        create_indice(response){
            this.$emit('create_indice', response)
        },
        update_indice(response){
            this.$emit('update_indice', response)
        }
    }
})